import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { PupillaryDistanceContent } from '../components/PupillaryDistanceContent/PupillaryDistanceContent.js';
import { StepWithAlerts } from '../components/StepWithAlerts/StepWithAlerts.js';
import { PrescriptionForm } from './components/PrescriptionForm/PrescriptionForm.js';
import { PrescriptionFormLabelDetails } from './components/PrescriptionFormLabelDetails/PrescriptionFormLabelDetails.js';

var PrescriptionFormStep = (_param)=>{
    var { description , image  } = _param, stepWithAlertsProps = swcHelpers.objectWithoutProperties(_param, [
        "description",
        "image"
    ]);
    const hasExtraInfo = Boolean(description || image);
    return /*#__PURE__*/ React.createElement(StepWithAlerts, swcHelpers.extends({}, stepWithAlertsProps, {
        textAlignment: "left"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "rx-form-step"
    }, hasExtraInfo && /*#__PURE__*/ React.createElement(PupillaryDistanceContent, {
        className: "rx-form-step__pd-content",
        description: description,
        image: image
    }), /*#__PURE__*/ React.createElement(PrescriptionFormLabelDetails, null), /*#__PURE__*/ React.createElement(PrescriptionForm, {
        className: "rx-form-step__form"
    })));
};

export { PrescriptionFormStep };
//# sourceMappingURL=PrescriptionFormStep.js.map
